const statusDialogConstatnsEn = {
  publishBlogTitle: 'Publish',
  publishBlogContent: 'Are you sure you want to Publish this item?',
  unPublishBlogTitle: 'UnPublish',
  unPublishBlogContent: 'Are you sure you want to Unpublish this item?',
  dialogConfirmButton: 'Yes',
  dialogCancelButton: 'No',
};
export default statusDialogConstatnsEn;
